import React, { useEffect, useRef, useMemo } from 'react';

import MyIcon from '../my-icon';

import style from './index.less';

interface PropTypes {
  mode?: 'position' | 'flex' | 'height';
  vertical?: 'normal' | 'center';
  className?: string;
  icon?: string;
  size?: 'small' | 'normal' | 'large';
  title?: string;
  description?: string | string[];
  imgUrl?: string;
  disabledIcon?: JSX.Element | boolean;
}

const iconSizeMap = {
  small: 24,
  normal: 60,
  large: 160
};

const Empty = ({
  mode = 'position',
  vertical = 'normal',
  icon = '',
  className = '',
  imgUrl = '',
  size = 'normal',
  title = '',
  description = '暂无数据',
  disabledIcon = false
}: PropTypes): JSX.Element => {
  const empty = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (mode === 'position') {
      const { current } = empty;
      if (current) {
        const { parentElement } = current;
        if (parentElement) {
          parentElement.style.position = 'relative';
        }
      }
    }
    return () => {
      if (mode === 'position') {
        const { current } = empty;
        if (current) {
          const { parentElement } = current;
          if (parentElement) {
            parentElement.style.position = '';
          }
        }
      }
    };
  }, [mode]);

  const emptyClassName = useMemo(() => {
    const classList = [];
    if (mode === 'position') {
      classList.push(style.position_children);
    } else {
      classList.push(style.flex_children);
    }
    if (vertical) {
      classList.push(style.center);
    }
    if (mode === 'height') {
      classList.push(style.height_children);
    }
    return classList.join(' ');
  }, [mode, vertical]);

  const desc = useMemo(() => {
    if (description && typeof description === 'string') {
      return (
        <div style={{ paddingTop: 8 }} className={style.desc}>
          {description}
        </div>
      );
    }
    if (Array.isArray(description)) {
      return (
        <div style={{ paddingTop: 8 }}>
          {description.map(desc => (
            <div className={style.desc}>{desc}</div>
          ))}
        </div>
      );
    }
    return null;
  }, [description]);

  const imgStyle = useMemo(() => {
    return { height: size, width: size };
  }, [size]);

  const iconEle = useMemo(() => {
    if (disabledIcon) {
      return null;
    }
    return imgUrl ? (
      <img alt="" src={imgUrl} className={style.img} style={imgStyle} />
    ) : (
      <MyIcon type={icon} style={{ fontSize: iconSizeMap[size] }} />
    );
  }, [imgStyle, imgUrl, disabledIcon, size]);

  return (
    <div className={`${emptyClassName} ${className}`} ref={empty}>
      <div className={style.content}>
        {iconEle}
        {title ? <div className={style.title}>{title}</div> : null}
        {desc}
      </div>
    </div>
  );
};

export default Empty;
